<template>
<div class="auth-form">
    <h2 class="auth-form__title text-center">{{t.h_login}}</h2>
    <div class="auth-form__text auth-form__text_social">{{t.login_social}}</div>
    <div class="text-center">
        <div v-if="!oauthUrls" class="loader"></div>
        <div v-if="oauthUrls" class="auth-form__social-buttons">
            <a v-if="oauthUrls.facebook" :href="oauthUrls.facebook" class="btn btn-primary auth-form__social-button auth-form__social-button_facebook"><img src="/img/icons/Social/facebook-icon.png" srcset="/img/icons/Social/facebook-icon@2x.png 2x" alt=""> Facebook</a>
            <a v-if="oauthUrls.google" :href="oauthUrls.google" class="btn btn-primary auth-form__social-button auth-form__social-button_google"><img src="/img/icons/Social/google-icon.png" srcset="/img/icons/Social/google-icon@2x.png 2x" alt=""> Google</a>
        </div>
    </div>
    <div class="auth-form__text auth-form__text_email">{{t.login_email}}</div>
    <div class="auth-form__form">
        <form :action="url" method="post" @submit.prevent="submit">
            <div class="form-group">
                <label for="loginform-email">{{t.email}}</label>
                <input type="text" class="form-control" name="email" v-model="formData.email" id="loginform-email" :disabled="loading">
                <div v-if="formErrors.email" class="form-text text-danger">{{formErrors.email}}</div>
            </div>
            <div class="form-group">
                <a class="float-right" href="#" @click.prevent="$emit('recover')">{{t.forgot_password}}</a>
                <label for="loginform-password">{{t.password}}</label>
                <input type="password" class="form-control" name="password" v-model="formData.password" id="loginform-password" :disabled="loading">
                <div v-if="formErrors.password" class="form-text text-danger">{{formErrors.password}}</div>
            </div>
            <div id="login-recaptcha-container"></div>
            <div v-if="formErrors['g-recaptcha-response']" class="form-text text-danger">{{formErrors['g-recaptcha-response']}}</div>
            <div class="form-group form-group-submit mt-3">
                <button class="btn btn-shadow-primary btn-block" type="submit" :disabled="loading">{{t.login}}</button>
            </div>
        </form>
    </div>
    <hr>
    <div class="text-center">
        <span class="mr-2">{{t.not_registered}}</span>
        <a href="#" @click.prevent="$emit('register')">{{t.register}}</a>
    </div>
</div>
</template>

<script>
import { loadOauthUrls } from '../helpers/oauth';

export default {
    data() {
        return {
            oauthUrls: null,
            loading: false,
            formData: {},
            formError: false,
            formErrors: {},
            recaptchaWidgetId: null
        };
    },
	methods: {
		formValidate() {
			this.formErrors = {};
            for (var field of ['email','password']) {
                if (!this.formData[field]) {
                    this.formErrors[field] = this.t.e_required;
                }
            }
            this.formError = Object.keys(this.formErrors).length != 0;
            return !this.formError;
        },
        submit() {
            if (this.formValidate()) {
                this.$root.recaptchaExecute(this.recaptchaWidgetId);
            }
        },
        sendData() {
            this.loading = true;
            $.ajax({
                url: this.url,
                data: this.formData,
                type: 'post',
                dataType: 'json',
                success: function (data) {
                    if (data.success) {
                        window.location.reload();
                    } else {
                        this.loading = false;
                        this.formError = true;
                        this.formErrors = data.errors;
                        this.$root.recaptchaReset(this.recaptchaWidgetId);
                    }
                }.bind(this)
            });
        }
	},
    computed: {
        
    },
    props: ['t','url'],
    created() {
        loadOauthUrls(urls => this.oauthUrls = urls);
    },
    mounted() {
        this.recaptchaWidgetId = this.$root.recaptchaRender('login-recaptcha-container', (token) => {
            this.formData['g-recaptcha-response'] = token;
            this.sendData();
        });
    },
    destroyed() {
        this.$root.recaptchaReset(this.recaptchaWidgetId);
    }
}
</script>

<style>
    
</style>